export const RequestEntitiesAndContactsByLayerType = `
    query requestEntitiesAndContactsByLayerType ($type: String!) {
        layerByType (type: $type) {
            layername
            entitiesByLayerid {
                nodes {
                    fullUid
                    name
                    membertype
                    websiteurl
                    phone
                    email
                    notes
                    instruc
                    datelastchanged
                    description
                    document
                    entitycontactsByFullUid {
                        nodes {
                            contactByPocid {
                                pocid
                                name
                                cell
                                land
                                email
                                pubconinfo
                                instruc
                                datelastchanged
                                document
                            }
                        }
                    }
                    entitygeometryByFullUid {
                        theGeom
                        objectid
                        fid2
                        geoType
                        type
                    }
                }
            }
        }
    }
`
